module.exports = __webpack_public_path__ + "static/media/JosefinSans-Light.a86bd2e8.ttf";